import { render, staticRenderFns } from "./GetCustomerMarketingInfo.vue?vue&type=template&id=fc517ea8&scoped=true&"
import script from "./GetCustomerMarketingInfo.vue?vue&type=script&lang=js&"
export * from "./GetCustomerMarketingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc517ea8",
  null
  
)

export default component.exports